import Chip from "@vapor/react-material/Chip";
import styled from "@emotion/styled";

interface StyledChipProps {
  categorylabel: string;
  selectedchip: string | null;
}
interface StyledStickyBoxProps {
  isEmbeded: string | null;
}
export const StyledChip = styled(Chip)<StyledChipProps>`
  && {
    ${(props) =>
      props.categorylabel === props.selectedchip
        ? {
            backgroundColor: "#DBF3FF",
            borderColor: "#008FD6",
            borderWidth: "1px",
            color: "#004E75",
            borderRadius: "4px",
          }
        : {
            backgroundColor: "white",
            color: "white",
            // borderWidth: "1px",
            borderRadius: "4px",
          }}
  }
`;

export const StyledStickyBox = styled.div<StyledStickyBoxProps>`
  position: sticky;
  top: ${(props) => (props.isEmbeded ? "-1px" : "45px")};
  z-index: 10;
  margin-left: 16px;
  margin-right: 16px;
  padding-top: 10px;
  background-color: white;
  text-align: left;
  max-width: 100%;
`;
